<template>
	<div>
		<div class="mnt-notice">
			<div class="mnt-notice__inner">
				<MaintenanceIcon name="info" class="mnt-notice__icon" />
				<p class="mnt-notice__text">
					Important notice: {{ subject }} has suspended all crypto-asset services.
					No new clients, accounts or transactions are accepted.
				</p>
			</div>
		</div>
		<header class="mnt-header">
			<div class="mnt-container">
				<router-link to="/" class="mnt-header__logo">
					<img src="./../images/logo.svg" alt="DaxChain" />
				</router-link>
			</div>
		</header>
	</div>
</template>

<script>
import MaintenanceIcon from './MaintenanceIcon.vue';

export default {
	name: 'MaintenanceHeader',
	components: { MaintenanceIcon },
	computed: {
		subject() {
			return this.$parent.maintenanceInfo.companyName || 'the platform';
		},
	},
};
</script>
